import RenderMixinMobile from '@/agilis/mobile/ListCardMobileMixins/renderMixinMobile'
import { mapGetters } from 'vuex'
import Configuration from '@/agilis/util/Configuration'
import TrackerDataTableItemChildren
from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableItemChildren/TrackerDataTableItemChildren'
import L from 'lodash'
export default {
  name: 'TrackerDataTableItemChildrenMobile',
  mixins: [RenderMixinMobile, TrackerDataTableItemChildren],
  data () {
    return {
      cardItemList: [],
      loading: false
    }
  },
  async mounted () {
    await this.fetchDataChildren()
  },
  computed: {
    ...mapGetters({
      userId: 'userDataStore/userId',
      selectedContext: 'contextStore/selectedContext',
      applicationId: 'contextStore/applicationId',
      workspaceId: 'contextStore/workspaceId',
      trackerTypeId: 'contextStore/trackerTypeId',
      trackerType: 'contextStore/trackerType',
      trackerTypes: 'contextStore/trackerTypes',
      mode: 'contextStore/contextMode',
      trackerId: 'contextStore/trackerId',
      dataTableById: 'contextStore/trackerDataTableById'
    }),
    childrenConfig () {
      let configuration = L.cloneDeep(Configuration.simpleTable.getChildrenTable(this.applicationId, this.trackerTypeId))
      configuration.columns = configuration.columns.reduce((acc, current) => {
        acc[current.id] = current
        return acc
      }, {})
      return configuration
    },
    itemLayout () {
      return Configuration.datatable.getDatatable(
        {
          applicationId: this.applicationId,
          trackerTypeId: this.trackerTypeId,
          workspaceId: this.workspaceId }).mobile?.childrenItemLayout
    }
  },
  methods: {
    handleChildClick (childTracker) {
      // only the proposition is currently configured
      if (childTracker.trackerTypeId === 'proposition') {
        this.$router.agilis.viewTracker({
          trackerId: childTracker.id,
          trackerTypeId: childTracker.trackerTypeId,
          parentTrackerId: this.trackerId
        })
      }
    },
    groupName (group) {
      return this.$t(Configuration.getTrackerType(this.applicationId, group).name)
    },
    groupedItems (items) {
      return items.reduce((acc, item) => {
        const groupName = item.trackerTypeId
        if (!acc[groupName]) {
          acc[groupName] = []
        }
        acc[groupName].push(item)
        return acc
      }, {})
    },
    renderColumn (colId, item) {
      const colConfig = this.childrenConfig.columns[colId]
      return Configuration.datatable.renderColumn(colConfig, item)
    },
    async fetchDataChildren () {
      try {
        this.loading = true
        const url = this.$axios.agilisUrlTrackerChildren(
          this.applicationId,
          this.trackerTypeId,
          this.trackerId)
        const response = await this.axios.get(url, this.$axios.agilisRequestConfig(url))
        this.loading = false
        this.trackerWithChildren = response.data
        if (this.trackerWithChildren.childTrackers) {
          const children = this.trackerWithChildren.childTrackers.map(c => c.tracker)
          this.cardItemList = this.groupedItems(children)
          this.$emit('childrenLoaded', children)
        }
      } catch (error) {
        this.notifyError(error)
        this.loading = false
      }
    }
  }
}
